
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'VacanciesBannerBlock',

  head: function () {
    const isTablet = this.$store.state.device.device.isTablet;
    const isMobile = this.$store.state.device.device.isMobile;
    const isVideo = this.extras.video;

    let links = [
      {
        as: "image",
        rel: "preload",
        href: this.mainImage,
        type: "image/webp",
        media: "(max-width: 1024px)"
      }
    ];
    if (Boolean(!isTablet && !isMobile) && !isVideo) {
      links.push(
        {
          as: "image",
          rel: "preload",
          href: this.mainImage,
          type: "image/webp",
          media: "(min-width: 1024px)"
        }
      )
    }

    return {
      link: links,
    };
  },

  computed: {
    localValues: function () {
      return this.externalData?.VacanciesBannerBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
    isVisibleVideo: function () {
      if (!process.client) {
        return false;
      }
      if (!this.extras.video) {
        return false;
      }
      if (window.innerWidth <= 1023) {
        return false;
      }
      return true;
    },
    mainImage: function () {
      const isTablet = this.$store.state.device.device.isTablet;
      const isMobile = this.$store.state.device.device.isMobile;

      let width = 1920;
      if (isTablet) {
        width = 1023;
      }
      if (isMobile) {
        width = 640;
      }

      return this.$img(String(this.localValues.image), {
        width: width,
        height: 500,
        fit: 'cover',
      });
    },
  },
  methods: {
    startVideo: function () {
      if (!this.extras.video) {
        return;
      }
      if (window?.innerWidth < 1024) {
        return;
      }
      if (!this.$refs.refVideo) {
        setTimeout(() => {
          this.startVideo();
        }, 500);
        return;
      }
      // preload="metadata": перед play() страхуемся, что браузер начал загрузку ресурса
      if (this.$refs.refVideo.readyState === 0) { this.$refs.refVideo.load(); }
      const playPromise = this.$refs.refVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(() => {}); }
    },
  },
  mounted: function () {
    this.startVideo();
  },
});
